import { NavItem, NavItemAccessor } from '@billy/design-system'
import { TFunction } from 'i18next'

import { BookkeepingTag, BookkeepingTagCategory } from '../types/bookkeepingTag'
import { BookkeepingTagNavItemValue } from '../types/bookkeepingTagNavItemValue'
import { isBookkeepingTagCategory } from './isBookkeepingTagCategory'

const getSubItems = (bookkeepingTagCategory: BookkeepingTagCategory): NavItem<BookkeepingTagNavItemValue>[] => {
  const accessorGroupId = `subitem-${bookkeepingTagCategory.name}`

  const subItems: NavItem<BookkeepingTagNavItemValue>[] = [
    {
      id: accessorGroupId,
      accessor: NavItemAccessor.Header,
      children: bookkeepingTagCategory.question.name,
      value: {} as BookkeepingTagNavItemValue,
    },
  ]

  for (const response of bookkeepingTagCategory.question.answers) {
    subItems.push({
      id: response.name,
      accessorGroupId,
      children: response.name,
      value: {
        tag: bookkeepingTagCategory,
        response,
      },
    })
  }

  return subItems
}

export const getItems = (
  bookkeepingTags: (BookkeepingTag | BookkeepingTagCategory)[],
  t: TFunction,
): NavItem<BookkeepingTagNavItemValue>[] => {
  const HEADER_ID = 'header'
  const items: NavItem<BookkeepingTagNavItemValue>[] = []

  if (bookkeepingTags.length > 0) {
    items.push({
      id: HEADER_ID,
      accessor: NavItemAccessor.Header,
      children: t('select.bookkeeping_hero.suggested_category', { count: bookkeepingTags.length }),
      value: {},
    })
  }

  for (const bookkeepingTag of bookkeepingTags) {
    const item: NavItem<BookkeepingTagNavItemValue> = {
      id: bookkeepingTag.name,
      accessorGroupId: HEADER_ID,
      children: bookkeepingTag.name,
      value: {},
    }

    if (isBookkeepingTagCategory(bookkeepingTag)) {
      item.subItems = getSubItems(bookkeepingTag)
      item.value = {}
    } else {
      item.value = {
        tag: bookkeepingTag,
        response: bookkeepingTag,
      }
    }

    items.push(item)
  }

  return items
}
